import { render, staticRenderFns } from "./BasicPosPayment.vue?vue&type=template&id=14f2ad9e&scoped=true"
import script from "./BasicPosPayment.vue?vue&type=script&lang=js"
export * from "./BasicPosPayment.vue?vue&type=script&lang=js"
import style0 from "./BasicPosPayment.vue?vue&type=style&index=0&id=14f2ad9e&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f2ad9e",
  null
  
)

export default component.exports